import PortfolioCard from './PortfolioCard';

export default PortfolioCard;
